export const SALE_SLUG = 'sale'
